
import Vue from 'vue'
import Header from '@/components/layout/Header.vue'
import NavDrawerItems from '@/components/layout/NavDrawerItems.vue'
import gql from 'graphql-tag'
import Cookies from 'js-cookie'

interface Data {
  drawerOpen: boolean
  persistentDrawerOpen: boolean
  error: string
}

interface Methods {
  toggleDrawer: () => void
  logout: () => void
}

interface Computed {
  showError: boolean
}

export default Vue.extend<Data, Methods, Computed>({
  name: 'AdminLayout',
  data: () => ({
    drawerOpen: false,
    persistentDrawerOpen: true,
    error: ''
  }),
  components: {
    Header,
    NavDrawerItems
  },
  computed: {
    showError (): boolean {
      return !!this.error && this.error !== ''
    }
  },
  methods: {
    toggleDrawer () {
      this.drawerOpen = !this.drawerOpen
    },
    // TO DO - add back logout function once in UI
    async logout (): Promise<void> {
      try {
        const request = await this.$apollo.mutate({
          // Query
          mutation: gql`mutation {
            logout
          }`
        })
        if (request.data && !request.data.error) {
          Cookies.remove('login-token')
          Cookies.remove('login-id')
          this.error = ''
          this.$router.push('/login')
        } else {
          throw new Error(request.data?.error)
        }
      } catch (error) {
        this.error = (error as Error).message
      }
    }
  }
})
